import React, { useEffect, useContext } from 'react';
import { useNavigate, useLocation, useParams } from '@thd-olt-component-react/router';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { CustomerContext } from '@thd-olt-functional/customer-information';
import { declareContexts } from '@thd-olt-component-react/hydrator';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import '@thd-olt-component-react/placeholder/dist/component/placeholder.style.scss';
import { ProductList } from '@thd-olt-component-react/product-list';
import { BackToTop } from '@thd-olt-component-react/back-to-top';
import { extend } from '@thd-nucleus/data-sources';
import { Breadcrumbs } from '@thd-olt-component-react/breadcrumbs';
import { useAccountCrumbs } from '@thd-olt-component-react/customer-account-navigation';
import { LISTS_CRUMB } from '../../constants';

export const Shared = () => {
  declareContexts([ExperienceContext, CustomerContext]);
  const { listId } = useParams();
  const { search, pathname } = useLocation();
  const params = new URLSearchParams(search);
  const pageParam = params.get('page') || 1;
  const page = +pageParam;
  const navigate = useNavigate();

  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('list-shared.page-load');
  }, []);

  const goBackToListSummary = () => {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.delete('page');
    navigate({
      pathname: '/list/view/summary',
      search: searchParams.toString()
    });
  };

  const sharedCrumbs = useAccountCrumbs([
    LISTS_CRUMB,
    {
      path: pathname,
      label: 'List Details',
    },
  ]).map((crumb) => {
    return {
      label: crumb.label,
      url: crumb.path || crumb.url,
    };
  });

  return (
    <>
      <div className="sui-max-w-screen-2xl sui-mx-auto">
        <div className="sui-pt-5 sui-pl-4 sui-pb-6">
          <ErrorBoundary name="list-summary-breadcrumbs">
            <Breadcrumbs staticCrumbs={sharedCrumbs} />
          </ErrorBoundary>
        </div>
        <ErrorBoundary name="list-shared-details">
          <ProductList
            id={listId}
            onDelete={goBackToListSummary}
            page={page}
            isSharedList
            onSaveSharedList={goBackToListSummary}
          />
        </ErrorBoundary>
      </div>
      <ErrorBoundary name="list-shared-details-back-to-top">
        <BackToTop />
      </ErrorBoundary>
    </>
  );
};

Shared.displayName = 'MyListSharedPage';

Shared.dataModel = extend(
  ProductList,
  Breadcrumbs,
);
